"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doctorAttendingGenerateAccountingApiResponse = exports.accountingDoctorAttendingApiSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const doctor_attending_1 = require("./doctor-attending");
exports.accountingDoctorAttendingApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('accounting-doctor-attendings'),
    attributes: zod_1.z.object({
        period: zod_1.z.object({
            from: zod_1.z.coerce.string(),
            to: zod_1.z.coerce.string(),
        }),
        amountFeeCollected: zod_1.z.coerce.number(),
        amountMedicalAssistantFee: zod_1.z.coerce.number(),
        amountSubstituteMedicalAssistantFee: zod_1.z.coerce.number(),
        attendingShare: zod_1.z.coerce.number(),
        amountPaid: zod_1.z.coerce.number(),
        amountPayBack: zod_1.z.coerce.number(),
        amountCommissionFee: zod_1.z.coerce.number(),
        amountFee: zod_1.z.coerce.number(),
        amountAvailable: zod_1.z.coerce.number(),
        medicalAssistantShare: zod_1.z.object({
            doctorDuration: zod_1.z.coerce.number(),
            siteDuration: zod_1.z.coerce.number(),
            sharePercentage: zod_1.z.coerce.number(),
        }),
    }),
    relationships: zod_1.z.object({
        doctorAttending: (0, api_1.apiEntityRelationshipSchema)('doctor-attendings'),
    }),
});
exports.doctorAttendingGenerateAccountingApiResponse = zod_1.z.object({
    data: exports.accountingDoctorAttendingApiSchema,
    included: zod_1.z.array(doctor_attending_1.simpleDoctorAttendingApiSchema).optional().default([]),
});
